import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";

export default function Login() {
  let history = useHistory();
  const [email, setEmail] = useState("");
  const [tabs, setTabs] = useState("");
  const [tenant, setTenant] = useState("");
  const [showChannels, setShowChannels] = useState(true);
  const [language, setLanguage] = useState("");
  const [translations, setTranslations] = useState("");
  const [tags, setTags] = useState("");

  function validateForm() {
    return email.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (email) {
      localStorage.setItem(
        "user",
        JSON.stringify({
          name: "mike",
          email: email,
          tenant: tenant,
          tabs: tabs,
          show_channels: showChannels,
          language: language,
          translations: translations,
          tags: tags,
        })
      );

      history.push("/");
    }
  }

  return (
    <div className="Login" style={{ margin: 32 }}>
      <Form onSubmit={handleSubmit} autoComplete="off">
        <Form.Group size="lg" controlId="email" style={{ marginBottom: 24 }}>
          <Form.Label>Email</Form.Label>
          <Form.Control
            autoFocus
            autoComplete="false"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Label>Tenant</Form.Label>
          <Form.Control
            autoComplete="false"
            type="text"
            value={tenant}
            onChange={(e) => setTenant(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Label>Tabs stores</Form.Label>
          <Form.Control
            autoComplete="false"
            type="text"
            value={tabs}
            onChange={(e) => setTabs(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Label>Language</Form.Label>
          <Form.Control
            autoComplete="false"
            type="text"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Label>Translations</Form.Label>
          <Form.Control
            autoComplete="false"
            type="text"
            value={translations}
            onChange={(e) => setTranslations(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Label>Preference tags</Form.Label>
          <Form.Control
            autoComplete="false"
            type="text"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="subsId" style={{ marginBottom: 24 }}>
          <Form.Check
            // type="checkbox"
            checked={showChannels}
            label="Show channels"
            onChange={(e) => setShowChannels(e.target.checked)}
          />
        </Form.Group>
        <Button block size="lg" type="submit" disabled={!validateForm()}>
          Login
        </Button>
      </Form>
    </div>
  );
}
